import { render, staticRenderFns } from "./audit-history-manager.vue?vue&type=template&id=640db38c&scoped=true"
import script from "./audit-history-manager.ts?vue&type=script&lang=ts&external"
export * from "./audit-history-manager.ts?vue&type=script&lang=ts&external"
import style0 from "./audit-history-manager.less?vue&type=style&index=0&id=640db38c&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640db38c",
  null
  
)

export default component.exports